import React from 'react'
import { motion } from 'motion/react';

const HighlightsContent = ({title, items, handleHover, selectedItemIndex, largeFont}) => {
	
	return (
		<div className="highlights__content">
			{title ? <h3 className={`highlights__title ${largeFont ? 'highlights__title--large' : ''}`}>{title}</h3> : null}
			{items.length > 0 && <ul className="highlights__list">
				{items.map((item, i) => {
					const isSelected = i === selectedItemIndex;
					return <li className="highlight-item" key={item.title} onMouseEnter={() => handleHover(i)} >
					
						<h4 className="highlight-item__title">
							<a className="highlight-item__title__link" href={item.link.url} onFocus={() => handleHover(i)} >{item.title}</a>
						</h4>
						<span className={`highlight-item__arrow ${isSelected ? 'is-selected' : ''} `}></span>
						<motion.div 
							className="highlight-item__text"
							initial={false}
							animate={{ gridTemplateRows: isSelected ? '1fr' : '0fr' }}
						>
							<div className='highlight-item__text__container'>
								<p>{item.text}</p>
							</div>
						</motion.div>
					</li>
				})}
			</ul>}
		</div>
	)
}

export default HighlightsContent;
